import { IBuyBackProduct } from 'components/BuyBack/interfaces/buyBackInterfaces';
import getBuyBackCartConfig, {
    IBuyBackCartConfigResponse,
} from 'components/BuyBack/requests/getBuyBackCartConfigRequest';
import { useSelector } from 'react-redux';
import { useRequest } from 'redux-query-react';
import { useEffect, useState } from 'react';

export interface IBuyBackCartConfig {
    buyBackConfig?: IBuyBackCartConfigResponse;
}

const mapStateToProps = (state) => {
    return {
        buyBackConfig: state.entities?.buyBackCartConfig as IBuyBackCartConfigResponse,
    };
};

const useBuyBackCartConfig = (): IBuyBackCartConfig => {
    const config = useSelector(mapStateToProps);
    const [{}] = useRequest(getBuyBackCartConfig());
    const [buyBackConfig, setBuyBackConfig] = useState<IBuyBackCartConfigResponse>();

    useEffect(() => {
        if (config) {
            setBuyBackConfig(config.buyBackConfig);
        }
    }, [config]);

    return {
        buyBackConfig,
    };
};

export default useBuyBackCartConfig;
